const CheckedIcon = ({ width = 16, height = 10, color = 'white', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M0.736878 4.05218L1.67969 3.10938L4.59373 6.02347L4.59373 6.96628L3.65092 6.96628L0.736878 4.05218Z"
      fill={color}
    />
    <path
      d="M11.2552 1.81782L10.3124 0.875011L5.1713 6.01629L5.1713 6.9591L6.11411 6.9591L11.2552 1.81782Z"
      fill={color}
    />
  </svg>
)

export default CheckedIcon
